export const LEASE_PAYMENT = 'lease';
export const LOAN_PAYMENT = 'loan';
